import { useState } from "react";
import { Form, Upload, Image, Popconfirm, Button } from "antd";
import { FirebaseService, ToastService } from "@shared/lib/services";
import { FileSyncOutlined } from "@ant-design/icons";

interface InfluencerBulkUploadFormProps {
  onSubmit: (inputFileUrl: string) => void;
}

export function InfluencerBulkUploadForm({
  onSubmit,
}: InfluencerBulkUploadFormProps) {
  const [form] = Form.useForm();
  const [csvFileUrl, setCsvFileUrl] = useState("");

  const handleImageUpload = async (file: File) => {
    try {
      const uploadedUrl = await FirebaseService.uploadFileToFirebase(
        "bulk-upload-influencers",
        file
      );
      setCsvFileUrl(uploadedUrl);
      form.setFieldValue("csv", uploadedUrl);
    } catch (error) {
      ToastService.error("Csv upload failed. Please try again.");
    }
  };

  const handleDeleteCsv = () => {
    setCsvFileUrl("");
    form.setFieldValue("csv", "");
    ToastService.success("Csv removed successfully.");
  };

  const handleSubmit = (values: any) => {
    onSubmit(values?.csv);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      // className={styles.form}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <Form.Item
        label="Influencer csv"
        name="csv"
        rules={[{ required: true, message: "Brand csv is required" }]}
      >
        <Upload
          onChange={(info) =>
            info.file && handleImageUpload(info.file.originFileObj!)
          }
          showUploadList={false}
          accept="text/csv"
          beforeUpload={(file) => {
            const isImage = ["text/csv"].includes(file.type);
            if (!isImage) {
              ToastService.error("You can only upload Csv Files!");
            }
            return isImage; // Prevents upload if not a valid image
          }}
        >
          <Button> Upload</Button>
          <Button
            type="link"
            href="https://docs.google.com/spreadsheets/d/1nRMeenSi1UH5MgbZlkehVDK3GftebFizUxzE4Vwf9aA/edit?usp=sharing"
          >
            Sample Upload Link
          </Button>
        </Upload>
        {csvFileUrl && (
          <div style={{ marginTop: "16px" }}>
            <FileSyncOutlined size={20} />
            <Popconfirm
              title="Are you sure to delete this Csv?"
              onConfirm={handleDeleteCsv}
              okText="Yes"
              cancelText="No"
            >
              <Button type="link" danger>
                Delete Csv
              </Button>
            </Popconfirm>
          </div>
        )}
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {"Save"}
        </Button>
      </Form.Item>
    </Form>
  );
}
